var $88924f3e26506958$exports = {};
$88924f3e26506958$exports = {
    "breadcrumbs": `Morzsamen\xfc`
};


export {$88924f3e26506958$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
